// extracted by mini-css-extract-plugin
export default {"body":"body__3eh2YbSPxxPEd4VIgFfLm-","pageContent":"pageContent__S6V0kil6ia62AuG5_ehoH","pageContentHeader":"pageContentHeader__3QYflLsaopZO8om7YQsQJY"};